<template>
    <div class="payment-container">
        <navbar :isHiddenlogin="false"></navbar>
        <step-bar :step="4"></step-bar>
        <!-- 商品列表 -->
        <div class="payment-main">
            <div class="product-list">
                <div class="product-item" v-for="item in orderInfo.goods" :key="item.id">
                    <img :src="require(`@/assets/images/home/${item.picture}.png`)" class="product-img" />
                    <div class="product-title">{{ item.name }}</div>
                    <div class="product-price">￥{{ item.price }}</div>
                    <div v-if="item.linePrice" class="product-origin">￥{{ item.linePrice }}</div>
                    <div class="product-count">×<span class="product-count-color"> {{ item.quantity }}</span></div>
                </div>
            </div>

            <!-- 总金额 -->
            <div class="total-row">
                <span class="total-label">应付总金额 :</span>
                <span class="total-amount">￥{{ orderInfo.orderTotalPrice }}</span>
            </div>

            <!-- 费用明细 -->
            <div class="fee-detail">
                <div class="fee-detail-info">
                    <span class="orderPrice">商品总金额 : ￥{{ orderInfo.orderPrice }} <em>(原价 : <i>￥{{ originPrice
                    }}</i>)</em></span>
                    <div class="shippingfee">
                        <span style="padding-left: 54px;">运费 : ￥{{ orderInfo.deliveryPrice }}</span>
                        <el-tooltip placement="top" effect="light" :enterable="false" :v-model="true"
                            popper-class="shipping-tooltip">
                            <div slot="content">
                                快递费计费规则：<br />北京、河北、天津、山西、辽宁、吉林、黑龙江、江苏、浙江、安徽、陕西、江西、山东、河南、湖北、湖南、上海、甘肃、重庆、宁夏、福建、内蒙古、四川：每本7元，每增加1本运费增加4元。每套12元，每增加1套增加12元。<br />贵州、广东、广西、云南：每本7元，每增加1本运费增加5元。每套13元，每增加1套增加13元。<br />青海、海南：每本9元，每增加1本运费增加6元。每套16元，每增加1套增加16元。<br />新疆、西藏：每本20元，每增加1本运费增加15元。每套38元，每增加1套增加38元。<br />一次性购买5套或20册及以上辅导教材的订单享受包邮（特殊地区除外）。<br />
                            </div>
                            <img class="doubt" src="@/assets/images/home/icon7.png" alt="">
                        </el-tooltip>
                    </div>
                </div>
            </div>

            <!-- 收货信息 -->
            <div class="address-row">
                寄送至：{{ orderInfo.deliveryProvince }}{{ orderInfo.deliveryCity }}{{ orderInfo.deliveryArea }}{{
                    orderInfo.deliveryStreet }}　收货人：{{ orderInfo.deliveryConsignee }}　{{ orderInfo.deliveryPhone }}
            </div>
            <div class="address-row" style="background-color: #FBF3C6; width: max-content;padding: 3px 0;">
                注：图书快递发出后，除质量问题不可退货。图书快递发出前，特殊原因可申请后酌情办理退货。
            </div>
            <!-- 支付方式 -->
            <div class="pay-section">
                <div class="pay-type">
                    <div class="pay-label">支付方式：</div>
                    <div class="pay-tabs">
                        <div v-for="(tab, idx) in payTabs" :key="tab"
                            :class="['pay-tab', { active: idx === activeTab }]" @click="activeTab = idx">
                            {{ tab }}
                        </div>
                    </div>
                </div>
                <!-- 微信支付 -->
                <div class="pay-content" v-if="activeTab === 0">
                    <div class="alipay-info"
                        style="position: relative;display: flex;flex-direction: column;align-items: center;gap: 12px;">
                        <img :src="wechatImg" class="alipay-img"
                            :style="{ filter: isWechatQrBlur ? 'blur(4px)' : 'none', borderRadius: '10px' }" />
                        <span style="color: #aeaeae;">（请打开微信扫码支付）</span>
                        <button v-if="showWechatRefresh" @click="handleWechatRefreshQr"
                            style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); z-index: 2; background: #2865D4; color: #fff; border: none; border-radius: 6px; padding: 8px 20px; font-size: 16px; cursor: pointer;">刷新二维码</button>
                    </div>
                </div>
                <div class="pay-content" v-else-if="activeTab === 1">
                    <div class="alipay-info"
                        style="position: relative;display: flex;flex-direction: column;align-items: center;gap: 12px;">
                        <img :src="alipayImg" class="alipay-img"
                            :style="{ filter: isQrBlur ? 'blur(4px)' : 'none', borderRadius: '10px' }" />
                        <span style="color: #aeaeae;">（请打开支付宝扫码支付）</span>
                        <button v-if="showRefresh" @click="handleRefreshQr"
                            style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); z-index: 2; background: #2865D4; color: #fff; border: none; border-radius: 6px; padding: 8px 20px; font-size: 16px; cursor: pointer;">刷新二维码</button>
                    </div>
                </div>
                <div class="pay-content" v-else>
                    <!-- 对公转账 -->
                    <template>
                        <div class="bank-transfer-info">
                            <div class="bank-row">
                                <span class="bank-label">公司名称：</span>中国招标公共服务平台有限公司
                                <!-- <span class="bank-tip">（该公司为中国招标投标协会设立的图书教材收款方，请放心支付）</span> -->
                            </div>
                            <div class="bank-row"><span class="bank-label">银行账号：</span>35120188000065249</div>
                            <div class="bank-row"><span class="bank-label">银行名称：</span>光大银行北京三里河支行</div>
                            <div class="bank-row"><span class="bank-label">支付凭证：</span></div>
                            <div class="upload-section">
                                <el-upload class="upload-demo" drag :http-request="handleUpload" :show-file-list="false"
                                    accept="image/jpeg,image/png,image/jpg,image/JPG,image/PNG,image/JPEG"
                                    :before-upload="beforeUpload">
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">将支付凭证拖到此处，或<em>点击上传</em></div>
                                    <div class="el-upload__tip">只能上传jpg/png文件</div>
                                </el-upload>
                                <div v-if="uploadImgs.length > 0" class="preview-container">
                                    <div v-for="(img, index) in uploadImgs" :key="index" class="preview-item">
                                        <img :src="img.url" class="preview-img" />
                                        <div class="preview-remove" @click="removeImg(index)">×</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button class="pay-btn" @click="handleComplete">完成</button>
                    </template>
                </div>
            </div>
        </div>
        <!-- 弹窗 -->
        <div v-if="showDialog">
            <div class="custom-dialog-mask" v-if="dialogType !== 'repeat'"></div>
            <div class="custom-dialog-mask" v-else></div>
            <div class="custom-dialog-box">
                <img src="@/assets/images/home/icon8.png" class="custom-dialog-icon" />
                <div class="custom-dialog-title">
                    {{ dialogType === 'success' ? '提交成功' : '已提交成功,请勿重复提交' }}
                </div>
                <div class="custom-dialog-text">
                    <span>
                        <span>温馨提示：</span><br />
                        <span v-if="!alipaySuccess">
                            <span
                                v-if="orderInfo.orderMethod === '3'">1、请等待管理员核实订单转账金额，核实无误后，订单状态将自动调整为"已付款"。<br /></span>
                            <span>
                                <span v-if="orderInfo.orderMethod === '3'">
                                    2、转账成功并核实无误的订单，将在5个工作日内安排发货，请您耐心等待。
                                </span>
                                <span v-else>
                                    1、预计在5个工作日内为您安排发货，请您耐心等待。
                                </span>
                            </span><br />
                            <span>
                                <span v-if="orderInfo.orderMethod === '3'">
                                    3、如需开具发票，请前往 <a href="javascript:void(0);" class="custom-dialog-link"
                                        @click="goToPersonCenter">个人中心</a>。
                                </span>
                                <span v-else>
                                    2、如需开具发票，请前往 <a href="javascript:void(0);" class="custom-dialog-link"
                                        @click="goToPersonCenter">个人中心</a>。
                                </span>
                            </span>
                        </span>
                        <span v-else>
                            <span>1、预计在5个工作日内为您安排发货，请您耐心等待。</span><br />
                            <span>2、如需开具发票，请前往 <a href="javascript:void(0);" class="custom-dialog-link"
                                    @click="goToPersonCenter">个人中心</a>。</span>
                        </span>
                    </span>
                </div>
                <button class="custom-dialog-btn" @click="goToIndex()">确认</button>
            </div>
        </div>
    </div>
</template>

<script>
import navbar from '@/components/nav.vue'
import stepBar from '@/components/step-bar.vue'
import { ref } from 'vue'
import { getOrder, uploadEvidence, payEvidence, evidenceList, Alipay, getOrderStatus, wxpay } from '@/api/api'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
import QRCode from 'qrcode'
export default {
    name: "Invoice",
    components: {
        navbar,
        stepBar
    },
    data() {
        return {
            orderId: '',
            products: [],
            productTotal: 0,
            shipping: 0,
            total: 0,
            address: '',
            receiver: '',
            phone: '',
            payTabs: ['微信支付', '支付宝', '对公转账'],
            activeTab: 0,
            tradeNo: '',
            merchantNo: '',
            uploadImgs: [],
            orderInfo: {},
            uploadUrl: process.env.VUE_APP_BASE_API + '/uploadEvidence',
            showDialog: false,
            dialogType: 'success', // 'success' 或 'repeat'
            originPrice: 0,
            alipayImg: '',
            pollingTimer: null,
            pollingCount: 0,
            isQrBlur: false,
            showRefresh: false,
            alipaySuccess: false,
            isPollingDialog: false,
            wechatImg: '',
            isWechatQrBlur: false,
            showWechatRefresh: false,
            wechatSuccess: false,
            wechatPollingTimer: null,
            wechatPollingCount: 0,
        }
    },
    computed: {
    },
    methods: {
        beforeUpload(file) {
            const isImage = file.type === 'image/jpeg' ||
                file.type === 'image/png' ||
                file.type === 'image/jpg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isImage) {
                this.$message.error('只能上传图片格式文件!');
            }

            return isImage;
        },
        async getWechatImg() {
            const res = await wxpay(this.orderId)
            if (res.code === 200) {
                QRCode.toDataURL(res.data, { width: 280, margin: 2 }, (err, url) => {
                    if (!err) {
                        this.wechatImg = url
                        this.isWechatQrBlur = false
                        this.showWechatRefresh = false
                        this.startPollingWechatOrderStatus()
                    } else {
                        this.wechatImg = ''
                    }
                })
            }
        },
        startPollingWechatOrderStatus() {
            if (this.wechatPollingTimer) {
                clearInterval(this.wechatPollingTimer)
            }
            this.wechatPollingCount = 0
            this.wechatPollingTimer = setInterval(async () => {
                this.wechatPollingCount++
                try {
                    const res = await getOrderStatus(this.orderId)
                    if (res.code === 200 && res.data && res.data.orderStatus === '4') {
                        clearInterval(this.wechatPollingTimer)
                        this.wechatPollingTimer = null
                        this.isWechatQrBlur = false
                        this.showWechatRefresh = false
                        this.getOrderInfo()
                        this.dialogType = 'success';
                        this.wechatSuccess = true;
                        this.isPollingDialog = true;
                        this.showDialog = true;
                    } else if (this.wechatPollingCount >= 100) {
                        clearInterval(this.wechatPollingTimer)
                        this.wechatPollingTimer = null
                        this.isWechatQrBlur = true
                        this.showWechatRefresh = true
                    }
                } catch (e) { }
            }, 3000)
        },
        handleWechatRefreshQr() {
            this.getWechatImg()
        },
        onClickUpload() {
            this.$refs.fileInput && this.$refs.fileInput.click()
        },
        onFileChange(e) {
            const file = e.target.files[0]
            if (file && file.type.startsWith('image/')) {
                const reader = new FileReader()
                reader.onload = ev => {
                    this.uploadImgs.push({
                        url: ev.target.result,
                        file: file
                    })
                }
                reader.readAsDataURL(file)
            }
        },
        onDrop(e) {
            const file = e.dataTransfer.files[0]
            if (file && file.type.startsWith('image/')) {
                const reader = new FileReader()
                reader.onload = ev => {
                    this.uploadImgs.push({
                        url: ev.target.result,
                        file: file
                    })
                }
                reader.readAsDataURL(file)
            }
        },
        removeImg(index) {
            this.uploadImgs.splice(index, 1)
        },
        async getOrderInfo() {
            try {
                const res = await getOrder(this.orderId)
                console.log(res)
                if (res.code === 200) {
                    this.orderInfo = res.data;
                    // 获取 Cookie 中的原价
                    const originTotal = Cookies.get('originTotal');
                    if (Number(originTotal)) {
                        this.originPrice = Number(originTotal);
                    } else {
                        for (let index = 0; index < res.data.goods.length; index++) {
                            const info = res.data.goods[index];
                            this.originPrice += Number(info.price) * Number(info.quantity);
                            console.log(Number(info.price) * Number(info.quantity));
                        }
                    }
                }
            } catch (error) {
                console.error('获取订单信息失败:', error)
            }
        },
        async getEvidenceList() {
            try {
                const res = await evidenceList(this.orderId)
                if (res.code === 200) {
                    this.uploadImgs = res.data.map(item => ({
                        url: item.link,
                        fileId: item.id,
                        isOriginal: true
                    }))
                }
            } catch (error) {
                console.error('获取凭证列表失败:', error)
            }
        },
        async handleComplete() {
            if (this.uploadImgs.length === 0) {
                Message.warning('请先上传支付凭证')
                return
            }
            try {
                const params = {
                    orderId: this.orderId,
                    evidences: this.uploadImgs
                        .filter(img => img.fileId)
                        .map(img => img.fileId)
                }
                const res = await payEvidence(params)
                if (res.code === 200) {
                    this.getOrderInfo()
                    this.dialogType = 'success';
                    this.alipaySuccess = false;
                    this.showDialog = true;
                    clearInterval(this.pollingTimer)
                } else {
                    Message.error(res.msg || '提交失败')
                }
            } catch (error) {
                Message.error('提交失败')
                console.error('提交失败:', error)
            }
        },
        goToPersonCenter() {
            this.showDialog = false;
            this.isPollingDialog = false;
            this.$router.push({ path: '/person/order' });
        },
        goToIndex() {
            this.showDialog = false;
            this.isPollingDialog = false;
            this.$router.push({ path: '/' });
        },
        async handleUpload(options) {
            const formData = new FormData()
            formData.append('file', options.file)
            formData.append('orderId', this.orderId)
            try {
                const res = await uploadEvidence(formData)
                if (res.code === 200) {
                    console.log(res)
                    this.uploadImgs.push({
                        url: URL.createObjectURL(options.file),
                        file: options.file,
                        fileId: res.data.id
                    })
                    Message.success('上传成功')
                } else {
                    Message.error(res.msg || '上传失败')
                }
            } catch (error) {
                Message.error('上传失败')
                console.error('上传失败:', error)
            }
        },
        async getAlipayImg() {
            const res = await Alipay(this.orderId)
            console.log('Alipay接口返回', res);
            if (res.code === 200) {
                QRCode.toDataURL(res.data, { width: 280, margin: 2 }, (err, url) => {
                    if (!err) {
                        this.alipayImg = url
                        this.isQrBlur = false
                        this.showRefresh = false
                        this.startPollingOrderStatus()
                        console.log('支付宝二维码生成', url);
                    } else {
                        this.alipayImg = ''
                        console.log('二维码生成失败', err);
                    }
                })
            }
        },
        startPollingOrderStatus() {
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer)
            }
            this.pollingCount = 0
            this.pollingTimer = setInterval(async () => {
                this.pollingCount++
                try {
                    const res = await getOrderStatus(this.orderId)
                    if (res.code === 200 && res.data && res.data.orderStatus === '4') {
                        clearInterval(this.pollingTimer)
                        this.pollingTimer = null
                        this.isQrBlur = false
                        this.showRefresh = false
                        this.getOrderInfo()
                        this.dialogType = 'success';
                        this.alipaySuccess = true;
                        this.isPollingDialog = true;
                        this.showDialog = true;
                    } else if (this.pollingCount >= 100) {
                        clearInterval(this.pollingTimer)
                        this.pollingTimer = null
                        this.isQrBlur = true
                        this.showRefresh = true
                    }
                } catch (e) { }
            }, 3000)
        },
    },
    mounted() {
        // 从 URL 获取 orderId
        this.orderId = this.$route.query.orderId;
        if (this.orderId) {
            this.getOrderInfo()
            if (this.activeTab === 0) {
                this.getWechatImg()
            } else if (this.activeTab === 1) {
                this.getAlipayImg()
            }
            if (this.$route.query.status === 'update') {
                this.getEvidenceList()
            }
        } else {
            console.error('未找到订单ID')
        }
    },
    watch: {
        orderInfo: {
            handler(val) {
                if (this.isPollingDialog) return;
                if (val && (val.orderStatus == 2 || val.orderStatus == 3 || val.orderStatus == 4)) {
                    this.dialogType = 'repeat';
                    this.showDialog = true;
                }
            },
            immediate: true,
            deep: true
        },
        activeTab(val) {
            if (val === 0) {
                this.getWechatImg()
            } else if (val === 1) {
                this.getAlipayImg()
            }
        }
    },
    beforeDestroy() {
        if (this.pollingTimer) {
            clearInterval(this.pollingTimer)
        }
        if (this.wechatPollingTimer) {
            clearInterval(this.wechatPollingTimer)
        }
    },
}
</script>

<style scoped>
.payment-container {
    padding: 0 0 40px 0;
    background-image: url('@/assets/images/home/container-bg.png');
    background-size: cover;
    background-repeat: no-repeat;
}

.payment-main {
    /* width: var(--main-width); */
    width: 1000px;
    margin: 0 auto;
}

.product-list {
    margin-top: 30px;
    /* border-bottom: 1px solid #eee; */
}

.product-item {
    display: flex;
    align-items: center;
    /* height: 48px; */
    padding: 0 10px;
    font-size: 16px;
    padding-right: 340px;
    /* border-top: 1px solid #f5f5f5; */
}

.product-item:first-child {
    border-top: none;
}

.product-img {
    width: 50px;
    margin-right: 12px;
    border-radius: 4px;
    border: 1px solid #f0f0f0;
    background: #fff;
}

.product-title {
    flex: 1 1 auto;
    color: #333;
    font-size: 16px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-price {
    color: #e53935;
    font-size: 16px;
    width: 90px;
    text-align: right;
    margin-left: 10px;
}

.product-origin {
    color: #bbb;
    text-decoration: line-through;
    font-size: 16px;
    width: 80px;
    text-align: right;
    margin-left: 10px;
}

.product-count {
    font-size: 16px;
    width: 50px;
    text-align: right;
    margin-left: 10px;
}

.product-count-color {
    color: #e53935;
}

.product-delete {
    color: #bbb;
    font-size: 18px;
    width: 30px;
    text-align: center;
    cursor: pointer;
    margin-left: 10px;
}

.total-row {
    margin-top: 30px;
    font-size: 22px;
    font-weight: bold;
    color: #222;
    display: flex;
    align-items: baseline;
    margin-left: 122px;
}

.total-label {
    width: 135px;
}

.total-amount {
    color: #C60300;
    font-size: 22px;
    font-weight: bold;
}

.fee-detail {
    margin-top: 15px;
    font-size: 18px;
    color: #222;
    display: flex;
    gap: 24px;
    margin-bottom: 30px;
    /* align-items: center; */
}

.fee-detail-info {
    display: flex;
    flex-direction: column;
}

.shippingfee {
    position: relative;
    width: max-content;
}

.orderPrice {
    margin-bottom: 15px;
}

.orderPrice em {
    margin-left: 15px;
    font-size: 14px;
}

.orderPrice i {
    text-decoration: line-through;
}

.doubt {
    width: 20px;
    position: absolute;
    top: -5px;
    right: -22px;
    cursor: help;
}

.fee-detail span:first-child {
    display: block;
    width: 120px;
    text-align: right;
    margin-left: 143px;
}

.fee-detail-info span {
    flex: 1;
    width: max-content !important;
}

.address-row {
    margin-top: 16px;
    color: #979797;
    font-size: 15px;
    padding-bottom: 0;
    margin-left: 125px;
    /* border-bottom: 1px solid #eee; */
}

.pay-section {
    margin-top: 40px;
}

.pay-type {
    display: flex;
    align-items: center;
}

.pay-label {
    height: 43.5px;
    font-size: 22px;
    font-weight: bold;
    color: #222;
    margin-bottom: 18px;
}

.pay-tabs {
    display: flex;
    width: 800px;
    overflow: hidden;
    margin: 0 0 30px 40px;
    gap: 30px;
}

.pay-tab {
    width: 240px;
    text-align: center;
    padding: 10px 0;
    font-size: 18px;
    color: #222;
    background: #fafbfc;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    border-radius: 5px;
}

.pay-tab:last-child {
    border-right: none;
}

.pay-tab.active {
    background: #2865D4;
    color: #fff;
    font-weight: bold;
}

.pay-content {
    text-align: center;
    margin-top: 30px;
    background: rgba(252, 252, 252, .8);
    padding: 40px 0;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.qr-box {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.qr-img {
    width: 280px;
    height: 280px;
    border: 12px solid #2ecc40;
    background: #fff;
    border-radius: 8px;
}

.qr-tip {
    margin-top: 12px;
    color: #2ecc40;
    font-size: 18px;
    font-weight: bold;
}

.pay-form {
    margin: 40px auto 0 auto;
    width: 700px;
    text-align: left;
}

.pay-form-title {
    font-size: 18px;
    color: #222;
    margin-bottom: 18px;
    font-weight: bold;
}

.pay-form-row {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    font-size: 16px;
}

.pay-form-row label {
    width: 120px;
    color: #222;
    display: flex;
    align-items: center;
    font-size: 16px;
}

.form-tip {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: #f5f5f5;
    color: #aaa;
    border-radius: 50%;
    text-align: center;
    line-height: 18px;
    font-size: 14px;
    margin-left: 4px;
    cursor: pointer;
    border: 1px solid #ddd;
}

.pay-input {
    width: 220px;
    height: 32px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin: 0 10px;
    padding: 0 8px;
    font-size: 16px;
}

.form-required {
    color: #e53935;
    font-size: 14px;
    margin-right: 10px;
}

.form-desc {
    color: #888;
    font-size: 14px;
    margin-left: 10px;
    flex: 1;
}

.pay-btn {
    display: block;
    width: 200px;
    height: 40px;
    background: #2865D4;
    color: #fff;
    font-size: 18px;
    border: none;
    border-radius: 6px;
    margin: 30px auto 0 auto;
    cursor: pointer;
    font-weight: bold;
    letter-spacing: 2px;
    transition: background 0.2s;
}

.pay-btn:hover {
    background: #135ecb;
}

.bank-transfer-info {
    /* width: 900px;
    margin: 0 auto 30px auto; */
    text-align: left;
    font-size: 18px;
    color: #222;
}

.bank-row {
    margin-bottom: 8px;
    line-height: 1.8;
}

.bank-label {
    font-weight: bold;
    margin-right: 6px;
    width: 90px;
    text-align: right;
    display: inline-block;
    color: #313131;
}

.bank-tip {
    color: #a2a2a2;
    font-size: 13px;
    margin-left: 4px;
}

.preview-container {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    justify-content: flex-start;
}

.preview-item {
    position: relative;
    width: 180px;
    height: auto;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
}

.preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.preview-remove {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 20px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s;
}

.preview-remove:hover {
    background: rgba(0, 0, 0, 0.7);
}

.upload-section {
    width: 600px;
    margin: 0px auto 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.upload-demo {
    width: 500px;
}

:deep(.el-upload-dragger) {
    width: 500px;
    height: 240px;
}

:deep(.el-upload-dragger .el-icon-upload) {
    margin: 40px 0 16px;
    font-size: 48px;
    color: #c0c4cc;
}

:deep(.el-upload__text) {
    color: #606266;
    font-size: 14px;
    text-align: center;
}

:deep(.el-upload__text em) {
    color: #409eff;
    font-style: normal;
}

:deep(.el-upload__tip) {
    font-size: 12px;
    color: #909399;
    text-align: center;
    margin-top: 8px;
}

.custom-dialog-mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.35);
    z-index: 2000;
}

.custom-dialog-box {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    width: 600px;
    z-index: 2001;
    text-align: center;
    padding: 25px 40px 25px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.custom-dialog-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
}

.custom-dialog-title {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 12px;
}

.custom-dialog-text {
    font-size: 15px;
    color: #444;
    line-height: 1.8;
    margin-bottom: 18px;
    text-align: left;
}

.custom-dialog-link {
    color: #2865D4;
    text-decoration: underline;
    cursor: pointer;
}

.custom-dialog-btn {
    width: 180px;
    height: 40px;
    background: #2865D4;
    color: #fff;
    font-size: 18px;
    border: none;
    border-radius: 6px;
    font-weight: bold;
    letter-spacing: 2px;
    cursor: pointer;
    margin-top: 8px;
    transition: background 0.2s;
}

.custom-dialog-btn:hover {
    background: #135ecb;
}
</style>